const V = {
  name: "Prize",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 2H18V5H22V10C22 11.6523 20.6523 13 19 13H17.9169C17.4951 15.5115 15.5115 17.4951 13 17.9169V20H17V22H7V20H11V17.9169C8.48848 17.4951 6.50488 15.5115 6.08306 13H5C3.34772 13 2 11.6523 2 10V5H6V2ZM16 12V4H8V12C8 14.2077 9.79228 16 12 16C14.2077 16 16 14.2077 16 12ZM18 11H19C19.5477 11 20 10.5477 20 10V7H18V11ZM6 7H4V10C4 10.5477 4.45228 11 5 11H6V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as Prize
};
